import { ReactNode } from "react";

import { Navbar, NavLink } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export type SideBarProps = {
  items: LinkItem[];
  buttons: ButtonLink[];
  hidden: boolean;
};

type LinkItem = {
  link: string;
  label: string;
  icon: ReactNode;
};

type ButtonLink = {
  onClick: () => void;
  label: string;
  icon: ReactNode;
};

export const SideBar = ({ items, buttons }: SideBarProps) => {
  const navigate = useNavigate();

  const links = items.map((item) => (
    <NavLink
      fs="sm"
      key={item.label}
      active={location.pathname === item.link}
      icon={item.icon}
      label={item.label}
      onClick={() => navigate(item.link)}
    />
  ));

  const linkButtons = buttons.map((button) => (
    <NavLink
      fs="sm"
      key={button.label}
      onClick={button.onClick}
      icon={button.icon}
      label={button.label}
    />
  ));

  return (
    <Navbar withBorder width={{ xs: 240, sm: 260 }} p="md">
      <Navbar.Section grow>{links}</Navbar.Section>
      <Navbar.Section>{linkButtons}</Navbar.Section>
    </Navbar>
  );
};
